import * as React from 'react';
import { FormGroup, FormControlLabel, Grid, Switch } from '@material-ui/core';
import { IMemberSummary } from '../../_types/member';
import Membership from './Membership';

interface Props {
    member: IMemberSummary;
};

const Memberships: React.FC<Props> = (prop: Props) => {

    const [showCancelled, setShowCancelled] = React.useState<boolean>(false);

    const memberships = prop.member.memberships!
        .filter(membership => {
            return membership.cancelled === false || showCancelled === true;
        })
        .sort((a, b) => {
            return a.cancelled === b.cancelled ? 0 : a ? -1 : 1;
        })
        .map((membership, index) => {
            return <Grid item key={index}>
                <Membership membership={membership} member={prop.member} />
            </Grid>
        });

    return (
        <Grid container direction="column" justify="flex-start" alignItems="stretch">
            <FormGroup style={{ marginBottom: 20 }}>
                <FormControlLabel control={<Switch size="small" checked={showCancelled} onChange={n => setShowCancelled(!showCancelled)} />} label="Show Cancelled Memberships" />
            </FormGroup>
            {memberships}
        </Grid>
    )
}

export default Memberships;